import React from 'react';
import Svg, { Path } from 'react-native-svg';

interface PencilIconProps {
  size?: number;
  color?: string;
}

const PencilIcon: React.FC<PencilIconProps> = ({ size = 20, color = "#888888" }) => {
  return (
    <Svg width={size} height={size} viewBox="0 0 20 20" fill="none">
      <Path d="M4.16667 15.8333H5.345L13.1067 8.07167L11.9283 6.89334L4.16667 14.655V15.8333ZM17.5 17.5H2.5V13.9642L13.6958 2.76834C13.8521 2.61212 14.064 2.52435 14.285 2.52435C14.506 2.52435 14.7179 2.61212 14.8742 2.76834L17.2317 5.12584C17.3879 5.28211 17.4757 5.49404 17.4757 5.71501C17.4757 5.93598 17.3879 6.1479 17.2317 6.30418L7.7025 15.8333H17.5V17.5ZM13.1067 5.71501L14.285 6.89334L15.4633 5.71501L14.285 4.53667L13.1067 5.71501Z" fill={color}/>
    </Svg>
  );
};

export default PencilIcon;
